var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "section-layout" }, [
    _c("div", { staticClass: "form-row mx-0 layout-all" }, [
      _c(
        "div",
        { staticClass: "col-12 col-md-6 px-0 layout-section" },
        _vm._l(_vm.getFields(0), function(fieldData, m) {
          return _c("form-block", {
            key: m,
            staticClass: "form-group mx-3",
            attrs: { formdata: fieldData, formIndex: m }
          })
        }),
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-12 col-md-6 px-0 layout-section" },
        _vm._l(_vm.getFields(1), function(fieldData, m) {
          return _c("form-block", {
            key: m,
            class: _vm.formBlockStyles(fieldData),
            attrs: { formdata: fieldData, formIndex: m }
          })
        }),
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-16967a60", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16967a60","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/presentational/layouts/LayoutSplit.vue
// module id = null
// module chunks = 